import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, RevealStagger, staggerItem } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { processSteps } from "@/data/content";

export default function Process({ onQuote }) {
  return (
    <section className="py-14 lg:py-20 bg-white" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="max-w-2xl mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-pristine-aquadeep mb-4">How It Works</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-pristine-navy tracking-tight text-balance">
            A Clear, Simple Process
          </h2>
        </Reveal>

        <RevealStagger className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {processSteps.map((step) => (
            <motion.div
              key={step.n}
              variants={staggerItem}
              className="relative rounded-2xl border border-pristine-aqua bg-pristine-surface p-7 hover:border-pristine-aquadeep transition-colors"
            >
              <span className="font-heading text-5xl font-light text-pristine-aquamid">{step.n}</span>
              <h3 className="mt-4 font-heading text-xl font-medium text-pristine-navy">{step.title}</h3>
              <p className="mt-2.5 text-sm text-pristine-navy/65 leading-relaxed">{step.body}</p>
            </motion.div>
          ))}
        </RevealStagger>

        <Reveal delay={0.1} className="mt-12">
          <Button
            data-testid="process-cta"
            onClick={onQuote}
            className="rounded-full bg-pristine-blue hover:bg-pristine-bluehover text-white h-14 px-8 text-base font-semibold group transition-transform hover:scale-[1.03]"
          >
            Start With a Free Discussion
            <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
          </Button>
        </Reveal>
      </div>
    </section>
  );
}
